/** @jsxImportSource ../../i18n */
import React from 'react';
import { cx } from '../../theme/cx';

export const PageHeader = ({ eyebrow, title, description, actions, meta, icon: Icon, iconClassName, className }) => (
  <header className={cx('flex flex-col gap-5 lg:flex-row lg:items-end lg:justify-between', className)}>
    <div className="min-w-0">
      {eyebrow && <p className="eyebrow mb-2 text-gold-400/90">{eyebrow}</p>}
      <h1 className="flex items-center gap-3 font-display text-display-md font-normal text-fg sm:text-display-lg">
        {Icon && <Icon className={cx('h-7 w-7 flex-shrink-0', iconClassName || 'text-gold-400')} aria-hidden="true" />}
        {title}
      </h1>
      {description && <div className="mt-2 max-w-3xl text-[15px] leading-relaxed text-fg-muted">{description}</div>}
      {meta && <div className="mt-3 flex flex-wrap items-center gap-2">{meta}</div>}
    </div>
    {actions && <div className="flex flex-shrink-0 flex-wrap items-center gap-2">{actions}</div>}
  </header>
);
